function retirevePreviousNode(pathGraphFlow, currentNodeId) {
  if (pathGraphFlow && (pathGraphFlow === null || pathGraphFlow === void 0 ? void 0 : pathGraphFlow.nodes.length) > 1) {
    var currentActiveNodeIndex = pathGraphFlow === null || pathGraphFlow === void 0 ? void 0 : pathGraphFlow.nodes.findIndex(function (pathNode) {
      return pathNode.id === currentNodeId;
    });

    if (currentActiveNodeIndex) {
      var previousNode = pathGraphFlow.nodes[currentActiveNodeIndex - 1];

      if (previousNode) {
        return previousNode;
      }
    }
  }

  return;
}

export default retirevePreviousNode;
//# sourceMappingURL=retrievePreviousNode.js.map
